import React, { useEffect, useState } from 'react'
import {
	Typography,
	Paper,
	Button,
	IconButton,
	FormHelperText
} from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import BackupIcon from '@material-ui/icons/Backup'
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore'
import GetAppIcon from '@material-ui/icons/GetApp'
import firebase from '../firebase'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { saveAs } from '@progress/kendo-file-saver';
import { ReactComponent as LoadingClock } from './clock.svg'
import * as Moment from 'moment'
import 'moment/locale/de'
import 'moment/locale/it'
import './styles.css'

const styles = theme => ({
	main: {
		width: 'auto',
		display: 'block',
		margin: theme.spacing(1),
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'top center',
		[theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
			backgroundPosition: 'center center',
		},
	},
	paper: {
		marginTop: theme.spacing(1),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		textAlign: 'center',
		padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(2)}px`,
		[theme.breakpoints.up(620 + theme.spacing(3) * 2)]: {
			width: 600,
			marginLeft: 'auto',
			marginRight: 'auto',
		},
	},
	submit: {
		padding: 12,
	},
	input: {
		fontSize: 92,
	},
	formHelper: {
		textAlign: 'center',
		marginTop: -5,
	},
})

function Dashboard(props) {
	const { classes } = props
	const [apptitle] = useState(localStorage.getItem('apptitle'))
	const [isadmin, setIsadmin] = useState(false)
	const [admins, setAdmins] = useState([1, 2, 3])
	const { t, i18n } = useTranslation()
	const [logged, setLogged] = useState(false)
	const [isactive, setIsactive] = useState(false)
	const [isrestore, setIsrestore] = useState(false)
	const [backupdate, setBackupdate] = useState('')
	const [restoredat, setRestoredat] = useState('')

	Moment.locale(i18n.language)

	useEffect(() => {
		document.title = window.localStorage.getItem('apptitle') + ` - ${t('dashboard.label')}`
	}, [t])

	useEffect(() => {
		if (firebase.getCurrentUsername()) {
			setLogged(true)
			firebase.getAdmin().then(setAdmins)
			return
		} else {
			alert(t('loginfirst.label'))
			window.location.href = '/'
			setAdmins([])
			return null
		}
	}, [t])

	useEffect(() => {
		if (firebase.getCurrentUsername()) {
			firebase.checkClaims().then((idTokenResult) => {
				if (!!idTokenResult.claims.admin) {
					setIsadmin(true)
				} else {
					return
				}
			})
		}
	}, [])

	useEffect(() => {
		const unsubscribe = firebase.db.collection('backupinprogress').doc('25')
			.onSnapshot((snapshot) => {
				if (snapshot.exists) {
					setIsactive(true)
				} else {
					setIsactive(false)
				}
			})
		return () => unsubscribe()
	}, [])

	useEffect(() => {
		const unsubscribe = firebase.db.collection('backupdate').doc('backup')
			.onSnapshot((snapshot) => {
				if (snapshot.exists) {
					setBackupdate(snapshot.data().createdAt)
				}
			})
		return () => unsubscribe()
	}, [])

	useEffect(() => {
		const unsubscribe = firebase.db.collection('restoreinprogress').doc('25')
			.onSnapshot((snapshot) => {
				if (snapshot.exists) {
					setIsrestore(true)
				} else {
					setIsrestore(false)
				}
			})
		return () => unsubscribe()
	}, [])

	useEffect(() => {
		const unsubscribe = firebase.db.collection('backupdate').doc('restore')
			.onSnapshot((snapshot) => {
				if (snapshot.exists) {
					setRestoredat(snapshot.data().createdAt)
				}
			})
		return () => unsubscribe()
	}, [])

	return (
		<main className={classes.main}>
			<div className={classes.content}>
				{logged ?
					<span>
						{admins.length !== 0 ?
							<span></span>
							:
							<Paper className={classes.paper}>
								<br />
								<Button
									type="submit"
									variant="contained"
									color="secondary"
									onClick={makeAdmin}
									className={`${classes.submit}`}>
									{t('makeadmin.label')}
								</Button>
							</Paper>
						}
						{isadmin ?
							<Paper className={classes.paper}>
								<Typography component="h1" variant="h5" gutterBottom>
									<strong>{apptitle}</strong>
								</Typography>
								<br />
								<Typography variant="body1" gutterBottom>
									<strong>{t('backupfirestore.label')}</strong>
								</Typography>
								{isactive ?
									<label htmlFor="icon-button-file">
										<IconButton disabled color="primary" component="span">
											<img src='./backup.png' className='blink-image' style={{ position: 'absolute', width: 92 }} alt='Backup in progress' />
											<BackupIcon color='secondary' className={classes.input} />
										</IconButton>
										<FormHelperText className={classes.formHelper}>{t('backupinprogress.label')}</FormHelperText>
										<br />
										<LoadingClock style={{ width: 50 }} />
									</label>
									: isrestore ?
										<span>
											<label htmlFor="icon-button-file">
												<IconButton disabled color="primary" component="span">
													<BackupIcon color='secondary' className={classes.input} />
												</IconButton>
												<FormHelperText className={classes.formHelper}>{t('createbackup.label')}</FormHelperText>
											</label>
											<br />
											<Typography variant="body1" gutterBottom>
												{t('lastbackup.label')}: {Moment(backupdate).format('LLLL')}
											</Typography>
										</span>
										:
										<span>
											<label htmlFor="icon-button-file">
												<IconButton onClick={() => { makeBackup() }} color="primary" component="span">
													<BackupIcon color='secondary' className={classes.input} />
												</IconButton>
												<FormHelperText className={classes.formHelper}>{t('createbackup.label')}</FormHelperText>
											</label>
											<br />
											{backupdate ?
												<Typography variant="body1" gutterBottom>
													{t('lastbackup.label')}: {Moment(backupdate).format('LLLL')}
												</Typography>
												:
												<Typography variant="body1" gutterBottom>
													{t('nobackup.label')}
												</Typography>
											}
										</span>
								}
							</Paper>
							:
							<span></span>
						}
						<Paper className={classes.paper}>
							{isadmin ?
								<span>
									<Typography variant="body1" gutterBottom>
										<strong>{t('restorestorage.label')}</strong>
									</Typography>
									{backupdate ?
										<span style={{ textAlign: 'center', }}>
											{isactive ?
												<span>
													<IconButton disabled color="primary" component="span">
														<SettingsBackupRestoreIcon color='secondary' className={classes.input} />
													</IconButton>
													<FormHelperText className={classes.formHelper}>{t('restore.label')}</FormHelperText>
													<br />
													{restoredat ?
														<Typography variant="body1" gutterBottom>
															{t('lastrestore.label')}: {Moment(restoredat).format('LLLL')}
														</Typography>
														:
														<Typography variant="body1" gutterBottom>
															{t('norestore.label')}
														</Typography>
													}
													<br /><br />
													<Typography variant="body1" gutterBottom>
														<strong>{t('downloadjson.label')}</strong>
													</Typography>
													<IconButton disabled color="primary" component="span">
														<GetAppIcon color='secondary' className={classes.input} />
													</IconButton>
													<FormHelperText className={classes.formHelper}>{t('downloadbackup.label')}</FormHelperText>
												</span>
												: isrestore ?
													<span>
														<IconButton disabled color="primary" component="span">
															<img src='./restore.png' className='blink-image' style={{ position: 'absolute', width: 92 }} alt='Restore in progress' />
															<SettingsBackupRestoreIcon color='secondary' className={classes.input} />
														</IconButton>
														<FormHelperText className={classes.formHelper}>{t('restoreinprogress.label')}</FormHelperText>
														<br />
														<LoadingClock style={{ width: 50 }} />
														<br /><br />
														<Typography variant="body1" gutterBottom>
															<strong>{t('downloadjson.label')}</strong>
														</Typography>
														<IconButton disabled color="primary" component="span">
															<GetAppIcon color='secondary' className={classes.input} />
														</IconButton>
														<FormHelperText className={classes.formHelper}>{t('downloadbackup.label')}</FormHelperText>
													</span>
													:
													<span>
														<IconButton onClick={() => { restoreBackup() }} color="primary" component="span">
															<SettingsBackupRestoreIcon color='secondary' className={classes.input} />
														</IconButton>
														<FormHelperText className={classes.formHelper}>{t('restore.label')}</FormHelperText>
														<br />
														{restoredat ?
															<Typography variant="body1" gutterBottom>
																{t('lastrestore.label')}: {Moment(restoredat).format('LLLL')}
															</Typography>
															:
															<Typography variant="body1" gutterBottom>
																{t('norestore.label')}
															</Typography>
														}
														<br /><hr /><br />
														<Typography variant="body1" gutterBottom>
															<strong>{t('downloadjson.label')}</strong>
														</Typography>
														<IconButton onClick={() => { downloadBackup() }} color="primary" component="span">
															<GetAppIcon color='secondary' className={classes.input} />
														</IconButton>
														<FormHelperText className={classes.formHelper}>{t('downloadbackup.label')}</FormHelperText>
													</span>
											}
										</span>
										:
										<Typography variant="body1" gutterBottom>
											{t('nobackup.label')}
										</Typography>
									}
								</span>
								:
								<span>
									<Typography variant="h6" gutterBottom>
										{t('welcome1.label')}
									</Typography>
									<Typography variant="subtitle1" gutterBottom>
										{t('welcome2.label')}
									</Typography>
								</span>
							}
						</Paper>
					</span>
					:
					<span></span>
				}
			</div>
		</main>
	)

	async function makeAdmin() {
		if (!firebase.auth.currentUser.emailVerified) {
			alert(t('verify.label'))
		} else {
			try {
				const user = firebase.auth.currentUser
				const userId = user.uid
				const name = user.displayName
				const email = user.email
				await firebase.makeAdmin(userId, name, email)
				firebase.getAdmin().then(setAdmins)
				await firebase.logout()
					.then(() => {
						toast.success(`${t('admincreated.label')}`)
					})
					.then(() => {
						setTimeout(() => {
							window.location.href = '/'
						}, 1500)
					})
			} catch (error) {
				alert(error.message)
			}
		}
	}

	function makeBackup() {
		setIsactive(true)
		firebase.backupFirestore()
		toast.success(`${t('backupiscreated.label')}`)
	}

	async function downloadBackup() {
		var backupJson = await firebase.storage.ref('backup').child('backup.json').getDownloadURL()
		console.log(backupJson)
		var dateNow = parseInt(backupdate)
		var oReq = new XMLHttpRequest()
		var URLToJSON = 'https://cors-anywhere.herokuapp.com/' + backupJson
		oReq.open('GET', URLToJSON, true)
		oReq.responseType = 'blob'
		oReq.onload = () => {
			var file = new Blob([oReq.response], {
				tyle: 'application/json'
			})
			saveAs(file, 'backup' + Moment(dateNow).format() + '.json')
		}
		oReq.send()
	}

	function restoreBackup() {
		setIsrestore(true)
		toast.success(`${t('firestoreisrestored.label')}`)
		firebase.storage.ref('backup').child('backup.json').getDownloadURL()
			.then(url => {
				firebase.restoreFirestore(url, backupdate)
			})
	}

}

export default withRouter(withStyles(styles)(Dashboard))